import * as Yup from "yup";
import {alphaNumMessage} from "./messages";

export default function () {
    return Yup.string()
        .transform((value) => { return value ? String(value).trim() : value })
        .test('alphaNumWithSpecial', alphaNumMessage, (val) => {
            return !(/[<>$%^_+=?\\"|~{}\[\]]/gsu.test(val))
        })
}
